import { Minus, Plus } from 'lucide-react';

import type { CounterProps } from './types';

import { Button } from '@/components/ui/button';

/**
 * Counter component for incrementing/decrementing numeric values
 * Uses shadcn/ui Button components with Lucide icons
 */
export const Counter = (props: CounterProps) => {
  const {
    count,
    id,
    onChange,
    disabled = false,
    min = 1,
    max = Infinity,
  } = props;

  const onIncrement = () => {
    if (count < max) {
      onChange(count + 1, id);
    }
  };

  const onDecrement = () => {
    if (count > min) {
      onChange(count - 1, id);
    }
  };

  return (
    <div className="flex items-center gap-1">
      <Button
        type="button"
        variant="outline"
        size="icon-sm"
        aria-label="-"
        onClick={onDecrement}
        disabled={disabled || count <= min}
      >
        <Minus />
      </Button>
      <div className="flex min-w-7 items-center justify-center text-sm font-medium tabular-nums">
        {count}
      </div>
      <Button
        type="button"
        variant="outline"
        size="icon-sm"
        aria-label="+"
        onClick={onIncrement}
        disabled={disabled || count >= max}
      >
        <Plus />
      </Button>
    </div>
  );
};
